import { format, subDays } from 'date-fns';

/**
 * Date filter: either a from/to range or the last N days (never both).
 * from/to are 'yyyy-MM-dd' strings; a missing from means "since the beginning"
 * and a missing to means "until now".
 */
export const EMPTY_DATE_FILTER = { from: null, to: null, lastDays: null };

export const isDateFilterActive = ({ from, to, lastDays }) => Boolean(from || to || lastDays);

/**
 * Convert a date filter to the search API's date range ({ dateFrom, dateTo }).
 * "Last N days" includes today, so last 1 day = today only.
 */
export const toDateRange = ({ from, to, lastDays }) => {
    if (lastDays) {
        return { dateFrom: format(subDays(new Date(), lastDays - 1), 'yyyy-MM-dd'), dateTo: null };
    }
    return { dateFrom: from, dateTo: to };
};

const formatDay = (value) => format(new Date(value), 'MMM d');

/** Label for the filter button, e.g. "Date", "Date: Last 7 days" or "Date: Jan 3 – Now" */
export const describeDateFilter = ({ from, to, lastDays }) => {
    if (lastDays) return `Date: Last ${lastDays} day${lastDays === 1 ? '' : 's'}`;
    if (from || to) return `Date: ${from ? formatDay(from) : 'Start'} – ${to ? formatDay(to) : 'Now'}`;
    return 'Date';
};
